import React from 'react'
import { authRoles } from 'app/auth/authRoles'

const dataExportRoutes = [
    {
        path: '/data-export',
        component: React.lazy(() => import('./DataExportPage')),
        auth: authRoles.admin,
        accessPageName: 'SETTINGS',
        typeShow: ['fastfood'],
    },
]

export default dataExportRoutes
